/** SC-549 follow-up: surface the catalogue code next to the dish name on the
 * ordering site, so customers and the paper menu speak the same language.
 * Hidden when the name already contains the code as a standalone word (e.g.
 * SHUN FU menus renamed to "Menu T8") to avoid "T8 Menu T8" repetition. */
export function dishCodeBadge(name: string, code?: string | null): string | null {
  const c = (code ?? '').trim();
  if (!c) return null;
  const escaped = c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const asWord = new RegExp(`(^|[^\\p{L}\\p{N}])${escaped}([^\\p{L}\\p{N}]|$)`, 'iu');
  return asWord.test(name) ? null : c;
}
